/* eslint-disable import/no-cycle */
import { TEAM_MEMBER, TEAMS } from "lib/constants";
import { getAPICall, postAPICall, putAPICall, deleteAPICall } from "../lib/callApi";

export const fetchTeamsList = async (payload) => {
  const data = await getAPICall(TEAMS, true, payload);
  return data;
};

export const createTeam = async (payload) => {
  const data = await postAPICall(TEAMS, true, payload);
  return data;
};

export const editTeam = async (teamId, payload) => {
  const data = await putAPICall(`${TEAMS}/${teamId}`, true, payload);
  return data;
};

export const deleteTeam = async (teamId) => {
  const data = await deleteAPICall(`${TEAMS}/${teamId}`, true);
  return data;
};

export const fetchTeamList = async (payload) => {
  const data = await getAPICall(`${TEAM_MEMBER}/${payload.id}`, true, {
    pageSize: payload.pageSize,
    pageNumber: payload.pageNumber,
    searchBy: payload.searchBy,
    timezone: payload.timezone,
  });
  return data;
};

export const createTeamMember = async (payload) => {
  const data = await postAPICall(TEAM_MEMBER, true, payload);
  return data;
};
